import styled from "styled-components";

export const LiveStreamSlideStatusDetailsBox = styled.div`
    font-family: 888;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
`;